import { useForm } from 'react-hook-form';
import CustomInput from '@/components/common/CustomInput';
import CustomButton from '@/components/common/CustomButton';
import SeoHead, {
  DEFAULT_META_DESCRIPTION,
  DEFAULT_META_TITLE,
} from '../../components/common/SeoHead';
import Image from 'next/image';
import FloatingImages from '@/components/home/FloatingImages';

export default function SignUp() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = () => console.log('hi');

  return (
    <>
      <SeoHead
        title={DEFAULT_META_TITLE}
        description={DEFAULT_META_DESCRIPTION}
        path='/signup'
        disableTitleSuffix
      />
      <div
        className={` grid grid-rows-[20px_1fr_20px] items-center justify-items-center min-h-screen  bg-primary `}
      >
        <main className='flex flex-col  row-start-2 items-center justify-center  bg-background rounded-[50%] w-[40rem] h-[40rem] py-[6.125rem] px-[8.75rem] shadow-main relative'>
          <FloatingImages
            className='-left-[2rem] -top-[1.875rem]'
            height='h-40'
            width='w-40'
            src='/assets/images/home/home-1.png'
            transitionDelay={1}
          />
          <FloatingImages
            className='-right-[4.8125rem] top-[8rem]'
            height='h-[7.5rem]'
            width='w-[7.5rem]'
            src='/assets/images/home/home-2.png'
            transitionDelay={2}
          />
          <FloatingImages
            className='right-[7rem] -top-[2rem]'
            height='h-[5.4375rem]'
            width='w-[5.4375rem]'
            src='/assets/images/home/home-3.png'
            transitionDelay={3}
          />
          <FloatingImages
            className='-right-[1.875rem] -bottom-2'
            height='h-[8.75rem]'
            width='w-[8.75rem]'
            src='/assets/images/home/home-5.png'
            transitionDelay={4}
          />
          <FloatingImages
            className='-left-[6.875rem] bottom-[2.375rem]'
            height='h-[11.25rem]'
            width='w-[11.25rem]'
            src='/assets/images/home/home-4.png'
            transitionDelay={0}
          />

          <div className='flex flex-col items-center mb-[1.875rem]'>
            <Image
              className='mb-3.5'
              src={'/assets/images/logo-2.svg'}
              alt='Nexgo Logo'
              width={36}
              height={40}
              priority
            />
            <h5 className='text-2xl leading-10 font-semibold text-center capitalize'>
              Sign up
            </h5>
          </div>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className='w-full pb-4  relative'
          >
            {' '}
            <CustomInput
              name='fname'
              placeholder='First Name'
              type='text'
              register={register}
              rules={{
                required: 'First Name is required',
              }}
              errors={errors}
            />
            <CustomInput
              name='lname'
              placeholder='Last Name'
              type='text'
              register={register}
              rules={{
                required: 'Last Name is required',
              }}
              errors={errors}
            />
            <CustomInput
              name='email'
              placeholder='Email'
              type='email'
              register={register}
              rules={{
                required: 'Email is required',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Invalid email address',
                },
              }}
              errors={errors}
            />
            <CustomInput
              name='password'
              placeholder='Password'
              type='password'
              register={register}
              rules={{
                required: 'Password is required',
                minLength: {
                  value: 6,
                  message: 'Password must be at least 6 characters',
                },
              }}
              errors={errors}
            />
            <p className='text-center text-xs leading-5 text-black mt-5 mb-9'>
              By creating an account, you agree to our Terms of Service and have
              read and understood the Privacy Policy
            </p>
            <CustomButton
              label='submit'
              type='submit'
              className='w-full'
              onClick={() => {}}
            />
          </form>
        </main>
      </div>
    </>
  );
}
